import { Box, LinearProgress, Stack, Typography } from "@mui/material";
import { LogoMarca } from "../../../components/logo";


export const SplashScreen = (props:{loading:boolean,msg:string}) => {
    /*
     * page on splash screen content 
    side menu aling to left  with logo on top and content list itens skeleton
    main content with logo and loading indicator 
     */
    return (
        <Box sx={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center' }}>
            <Stack
                direction="column"
                spacing={4}
                justifyContent="center"
                alignItems="center"
            >
                <LogoMarca height={100} width={250} />
                <Box sx={{ width: '100%' }}>
                    {props.loading&&(
                        <LinearProgress />
                    )}
                    
                </Box>
                <Typography variant="caption" color="textSecondary">
                    {props.msg}
                </Typography>
            </Stack>
        </Box>
    )
}